<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> City</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="city.id === null">New</span>
              <span v-else>
                {{ city.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="city.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="state_id" class="col-sm-3 col-form-label text-left">State</label>
              <div class="col-sm-9">
                <select v-model="city.state_id" class="form-control">
                  <option v-for="s in stateList" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="area_id" class="col-sm-3 col-form-label text-left">State</label>
              <div class="col-sm-9">
                <select v-model="city.area_id" class="form-control">
                  <option v-for="a in areaList" :key="a.id" :value="a.id">{{ a.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updateCity" class="btn btn-sm btn-primary pull-right" v-show="city.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createCity" class="btn btn-sm btn-primary pull-right" v-show="city.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <!-- <pre>
      {{ city }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { cityUrl, getHeader } from '../../config'

export default {
  name: 'CityForm',
  props: ['city'],
  computed: {
    ...mapState({
      stateList: state => state.state.stateList,
      areaList: state => state.area.areaList
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateCity () {
      axios.put(cityUrl + '/' + this.city.id, this.city, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('City', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createCity () {
      axios.post(cityUrl, this.city, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
